"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdpConnectRequestStruct = void 0;
const superstruct_1 = require("superstruct");
exports.SdpConnectRequestStruct = (0, superstruct_1.type)({
    organisationId: (0, superstruct_1.string)(),
    placeId: (0, superstruct_1.string)(),
    printerId: (0, superstruct_1.string)(),
    printerCode: (0, superstruct_1.string)(),
    token: (0, superstruct_1.string)(),
    pullIntervalSeconds: (0, superstruct_1.number)(),
    /** Device ID of the TM printer registered in the SDP module's WebConfig (default: "local_printer") */
    externalDeviceId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
});
//# sourceMappingURL=SdpConnectRequest.js.map